var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{class:{ show: _vm.showButton },attrs:{"type":"primary","round":""},on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"tim-icons icon-up-arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }